"use strict";
/* burger menu */

let menuButton = document.querySelector(".btn--menu");
menuButton.addEventListener("click", toggleNavigation);

function toggleNavigation(){
    if(document.body.hasAttribute("data-menu")){
        document.body.removeAttribute("data-menu");
        menuButton.innerHTML = "Menu";
    }else{
        document.body.setAttribute("data-menu", true);
        menuButton.innerHTML = "Fermer";
    }
}

/* dark mode */
 
let btnLight = document.querySelector(".btn--light");
let btnDark = document.querySelector(".btn--dark");

let activeTheme = localStorage.getItem("theme");

if(activeTheme !== null){
	document.body.setAttribute("data-theme", activeTheme);
}

if(btnLight){ 
	btnLight.addEventListener("click", modeLight);
}

if(btnDark){
	btnDark.addEventListener("click", modeDark);
}

function modeLight(){
	document.body.setAttribute("data-theme", "dark");
	localStorage.setItem("theme", "dark");
}

function modeDark(){
	document.body.setAttribute("data-theme", "light");
	localStorage.setItem("theme", "light");
}

  // import Swiper bundle with all modules installed
  import Swiper from 'swiper/bundle';

const swiper = new Swiper('.swiper-container', {
    loop: true,
    autoHeight: true,
    pagination: {
        el: '.swiper-pagination',
    },
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
});